import { Injectable } from '@angular/core';
import { CommandFactoryService } from '../../../../core/service/factory/command-factory.service';
import { MultiselectCommand } from '../../../../core/model/command';
import { RentalObjectCategory } from '../../../model/const/enums';
import { RentalObjectMultiselectCommand } from '../../../command/rental-object.command';
import { RentalObjectFilteredCommand } from '../../../command/rental-object-filtered.command';

@Injectable()
export class ParkingRentalObjectCommandFactory extends CommandFactoryService {
  constructor() {
    super();
  }

  createFilteredCommand(id: string, excludedIds: string[], includedIds: string[], totalAffectedItemsControlValue: number) {
    return new RentalObjectFilteredCommand(id, excludedIds, includedIds, totalAffectedItemsControlValue, RentalObjectCategory.Parking);
  }
  createMultiselectCommand(id: string, items: any[], itemsSource: any[], contextId?: string): MultiselectCommand {
    return new RentalObjectMultiselectCommand(id, items, RentalObjectCategory.Parking, itemsSource, contextId);
  }
}
